export const HIDE_LOCATION_DENIED_MODAL = "HIDE_LOCATION_DENIED_MODAL";
export const hideLocationDeniedModal = () => ({
    type: HIDE_LOCATION_DENIED_MODAL,
});

export const SHOW_LOCATION_DENIED_MODAL = "SHOW_LOCATION_DENIED_MODAL";
export const showLocationDeniedModal = () => ({
    type: SHOW_LOCATION_DENIED_MODAL,
});
